import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { OraculoAnalise } from '@/types/agentesIa';

interface OraculoResultadoResponse {
  success: boolean;
  data: OraculoAnalise | null;
}

export function useOraculoResultado(
  empresaId: number | undefined,
  licitacaoId: number | undefined,
  refreshKey?: string
) {
  return useQuery<OraculoAnalise | null>({
    queryKey: ['oraculo-edital-resultado', empresaId, licitacaoId, refreshKey],
    queryFn: async () => {
      const response = await api.get<OraculoResultadoResponse>(
        `/empresas/${empresaId}/oraculo-edital`,
        { params: { licitacaoId } }
      );
      return response.data;
    },
    enabled: Boolean(empresaId && licitacaoId),
  });
}
